<script>
  // Patterns
  import Feature from '@/sections/1-feature.svelte';
  import Projects from '@/sections/2-projects.svelte';
  import Intro from '@/sections/3-intro.svelte';
  import Benefits from '@/sections/4-benefits.svelte';
  import Types from '@/sections/5-types.svelte';
  import Clients from '@/sections/6-clients.svelte';
  import Service from '@/sections/7-service.svelte';
  import Redirect from '@/sections/7a-redirect.svelte';
  import About from '@/sections/8-about.svelte';
  import Contact from '@/sections/9-contact.svelte';

  export let data;
  
  // Eidos
  $: feature = data.feature;
  $: projects = data.projects;
  $: intro = data.intro;
  $: benefits = data.benefits;
  $: clients = data.clients;
  $: service = data.service;
  $: types = data.types;
  $: about = data.about;
  $: contact = data.contact;

</script>

<style></style>

<main>
  <Feature {feature} />
  <Projects {projects} />
  <Intro {intro} />
  <Benefits {benefits} />
  <!-- <Types {types} /> -->
  <Clients {clients} />
  <Service {service} />
  <Redirect {service} />
  <About {about} />
  <Contact {contact} />
</main>